import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { errorMessage, getToken, setToken } from "./api";
import { AdminField, PrimaryButton } from "./ui";

export default function LoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        document.title = "Anmelden – En Edem Germania";
    }, []);

    if (getToken()) {
        return <Navigate to="/admin/bestellungen" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            const response = await axios.post("/api/public/auth/login", { email, password });
            setToken(response.data.token);
            navigate("/admin/bestellungen", { replace: true });
        } catch (err) {
            const tooMany = err.response && err.response.status === 429;
            setError(
                tooMany
                    ? errorMessage(err, "Zu viele Anmeldeversuche. Bitte in 15 Minuten erneut versuchen.")
                    : "Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.",
            );
            setBusy(false);
        }
    };

    return (
        <div className="site flex min-h-screen items-center justify-center p-6">
            <form onSubmit={submit} className="hero-in grid w-full max-w-[380px] gap-[22px]">
                <img src="/media/logo.png" alt="En Edem Germania" className="h-24 w-auto justify-self-center mix-blend-multiply" />
                <div className="text-center">
                    <h1 className="m-0 font-caslon text-[28px] font-normal">Verwaltung</h1>
                    <div className="mt-1 text-[13px] text-forest/55">En Edem Germania</div>
                </div>
                <AdminField
                    label="E-Mail"
                    type="email"
                    required
                    autoComplete="username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <AdminField
                    label="Passwort"
                    type="password"
                    required
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                {error && (
                    <div role="alert" className="text-sm text-fehler">
                        {error}
                    </div>
                )}
                <PrimaryButton type="submit" disabled={busy}>
                    {busy ? "Wird geprüft …" : "Anmelden"}
                </PrimaryButton>
            </form>
        </div>
    );
}
